var map = {
	"./CAVE.png": 39044,
	"./CAVE2.png": 99564,
	"./DUNGEON.png": 60981,
	"./FACTORY.png": 55073,
	"./FOREST.png": 88512,
	"./MOUNTAINS.png": 99963,
	"./NEUTRAL.png": 15742,
	"./PLAINS.png": 2956,
	"./RIVER.png": 88277,
	"./RUINS.png": 17266,
	"./SEA.png": 51854,
	"./TROPIC.png": 79092,
	"./VULCAN.png": 44766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51880;